define('bindingHandlers/privileged/inheritedFormControl',[
    'jquery',
    'lib/knockout',
    'lib/lodash4',
    'util/externalInclude',
    'services/loggingService'
], function ($, ko, _, externalInclude, LOG) {
    'use strict';

    var getElementToAdorn = function(element, customClass) {

        var elementToAdorn;

        if (_.isUndefined(customClass)) {
            elementToAdorn = $('label, input, select', element).first();
        }
        else {
            elementToAdorn = $('.' + customClass, element).first();
        }

        if (!elementToAdorn.length) {
            LOG.error('No valid inherited form control elements found to adorn.');
        }

        return elementToAdorn;
    };

    var getElementsToHighlight = function(element, customClass) {

        var elementToHighlight;

        if (_.isUndefined(customClass)) {
            elementToHighlight = $('input, select', element);
        }
        else {
            elementToHighlight = $('.' + customClass, element);
        }

        return elementToHighlight;
    };

    var highlightElements = function (element, options) {
        var isInherited = ko.unwrap(options.isInherited);
        var classToHighlight = ko.unwrap(options.classToHighlight);
        var showIcon = ko.unwrap(options.showIcon);

        var elementsToHighlight = getElementsToHighlight(element, classToHighlight);

        if (showIcon) {
            if (isInherited) {
                elementsToHighlight.addClass('inherited-form-control-state-inherit');
                elementsToHighlight.removeClass('inherited-form-control-state-override');
            } else {
                elementsToHighlight.removeClass('inherited-form-control-state-inherit');
                elementsToHighlight.addClass('inherited-form-control-state-override');
            }
        }
        else {
            elementsToHighlight.removeClass('inherited-form-control-state-inherit');
            elementsToHighlight.removeClass('inherited-form-control-state-override');
        }
    };

    /**
     * Use this on form controls that are inherited to style the UI and provide an option to see the inherited value
     * and reset back to inherited.  This binding will adorn the first label element if it exists, otherwise it will
     * adorn the control itself.
     *
     * showInheritance: - The control can show inheritance, or be simplified to only show default values.
     * isInherited - Observable that tells the control if the control is currently inheriting a value.
     * inheritedDisplayValue - When not inherited, this value will be shown to the user to tell them what the inherited value would be if they reset it.
     * resetToInherited - Called to reset the control back to being inherited.  How this is done is left to the caller.
     * setToOverridden - Called to set the control to overridden.  How this is done is left to the caller.
     * classToAdorn - (Optional) An optional class used to find the element to adorn.
     * classToHighlight - (Optional) An optional class used to find the element to color blue when overridden.
     * pullRight - (Optional) Defaults to true, setting this to false won't pull the adornment to the right.
     * showIcon - (Optional) Defaults to true, observable or computed that hides and shows the inheritance icon for the control.
     * disable - (Optional) Defaults to false, observable or computed that disables the control.
     * Usage Examples:
     *
     * // Icon to the right of the label
     * <div data-bind="inheritedFormControl: { isInherited: isInherited, inheritedDisplayValue: inheritedDisplayValue, resetToInherited: resetToInherited, setToOverridden: setToOverridden}">
     *     <label/>
     *     <input data-bind: {value: effectiveValue} />
     * </div>
     *
     * // Icon to the right of the input
     * <div data-bind="inheritedFormControl: { isInherited: isInherited, inheritedDisplayValue: inheritedDisplayValue, resetToInherited: resetToInherited, setToOverridden: setToOverridden}">
     *     <input data-bind: {value: effectiveValue} />
     * </div>
     *
     * * // Custom adornment and highlight
     * <div data-bind="inheritedFormControl: {
     *     showInheritance: showInheritance,
     *     isInherited: isInherited,
     *     inheritedDisplayValue: inheritedDisplayValue,
     *     resetToInherited: resetToInherited,
     *     setToOverridden: setToOverridden,
     *     classToAdorn="adorn-me",
     *     classToHighlight="highlight-me",
     *     showIcon: showIcon }"
     * >
     *     <span class="adorn-me"/>
     *     <span class="highlight-me" data-bind: {value: effectiveValue} />
     * </div>
     */
    ko.bindingHandlers.inheritedFormControl = {
        init: function (element, valueAccessor) {
            var options = ko.unwrap(valueAccessor());
            var classToAdorn = ko.unwrap(options.classToAdorn);
            var pullRight = ko.unwrap(options.pullRight);
            var showIcon = ko.unwrap(options.showIcon);
            var hasClassToHighlight = !_.isUndefined(options.classToHighlight);

            if (_.isUndefined(pullRight)) {
                pullRight = true;
            }

            if (_.isUndefined(showIcon)) {
                options.showIcon = ko.observable(true);
            }

            if (_.isUndefined(options.disable)) {
                options.disable = ko.observable(false);
            }

            options.popoverTitle = ko.i18n.renderString(
                'widget.inheritedFormControl.details'
            );

            options.firstItemHasFocus = ko.observable(false).extend({
                rateLimit: {
                    method: 'notifyWhenChangesStop',
                    timeout: 100,
                },
            });
            options.popoverIsOpen = ko.observable(false);
            options.popoverIsOpen.subscribe(function (newValue) {
                if (newValue) {
                    options.firstItemHasFocus(true);
                }
            });

            options.onResetToInherited = function () {
                options.resetToInherited();
                options.popoverIsOpen(false);
            };
            options.onSetToOverridden = function () {
                options.setToOverridden();
                options.popoverIsOpen(false);
            };

            options.id = _.uniqueId('inherited-control-popover-');

            $(element).addClass('inherited-form-control');

            var elementToAdorn = getElementToAdorn(element, classToAdorn);
            elementToAdorn.addClass(
                pullRight ? 'inherited-form-control-adorned-pull-right' : 'inherited-form-control-adorned'
            );

            var adornmentWrapper = $('<div/>');
            adornmentWrapper.addClass('inherited-form-control-wrapper');

            // Be sure to not remove the elementToAdorn from the DOM, as it may already be bound.
            adornmentWrapper.insertBefore(elementToAdorn);
            elementToAdorn.appendTo(adornmentWrapper);

            var inheritedIcon = $('<div/>');
            inheritedIcon.appendTo(adornmentWrapper);

            var template = 'templates/appMain/privilegedMain/inheritedFormControl';
            externalInclude.loadTemplate(template)
                .then(function () {
                    ko.renderTemplate( template, options, { afterRender: hasClassToHighlight ? highlightElements(element, options) : null }, inheritedIcon, 'replaceNode');
                });
        },
        update: function (element, valueAccessor) {
            var options = ko.unwrap(valueAccessor());

            highlightElements(element, options);
        }
    };
});

